import ReportModal, { ReportModalProps } from './ReportModal';

const ReportChatModal = (props: Omit<ReportModalProps, 'kind'>) => (
  <ReportModal {...props} kind="chat" />
);

export default ReportChatModal;
